import { Request, BaseApiUrl } from "./api";
//配比映射模块管理
export const addSysRecipeMappingPost = (params) => {
    return Request.post(`${BaseApiUrl}/api/SysRecipeMapping/Post`, params);
};
export const getSysRecipeMappingListPage = (params) => {
    return Request.get(`${BaseApiUrl}/api/SysRecipeMapping/Get`, { params: params });
};
export const getSysRecipeMappingDeatil = (params) => {
    return Request.get(`${BaseApiUrl}/api/SysRecipeMapping/Detail`, { params: params });
};
export const editSysRecipeMapping = (params) => {
    return Request.post(`${BaseApiUrl}/api/SysRecipeMapping/Put`, params);
};
export const removeSysRecipeMapping = (params) => {
    return Request.post(`${BaseApiUrl}/api/SysRecipeMapping/BatchDelete`, params);
};
export const getSysRecipeMappingBaseData = (params) => {
    return Request.get(`${BaseApiUrl}/api/SysRecipeMapping/GetBaseData`, { params: params });
};

//配比管理
export const addConsultRecipePost = (params) => {
    return Request.post(`${BaseApiUrl}/api/ConsultRecipe/Post`, params);
};
export const getConsultRecipeListPage = (params) => {
    return Request.get(`${BaseApiUrl}/api/ConsultRecipe/Get`, { params: params });
};
export const getConsultRecipeBaseData = (params) => {
    return Request.get(`${BaseApiUrl}/api/ConsultRecipe/GetConsultRecipeBaseData` );
};
export const getConsultRecipeDetail = (params) => {
    return Request.get(`${BaseApiUrl}/api/ConsultRecipe/Detail`, { params: params });
};
export const editConsultRecipe = (params) => {
    return Request.post(`${BaseApiUrl}/api/ConsultRecipe/Put`, params);
};
export const removeConsultRecipe = (params) => {
    return Request.delete(`${BaseApiUrl}/api/ConsultRecipe/Delete`, { params: params });
};
//批量删除
export const batchDelete = (params) => {
    return Request.post(`${BaseApiUrl}/api/ConsultRecipe/BatchDelete`, params);
};
// export const batchDelete = (params) => {
//     return Request.delete(`${BaseApiUrl}/api/ConsultRecipe/BatchDelete`, {
//       data: params,
//       headers: {
//         "Content-Type": "application/json-patch+json",
//       },
//     });
//   };
// 生产线管理
// 列表
export const getSysStationLineListPage = (params) => {
    return Request.get(`${BaseApiUrl}/api/SysStationLine/get`, { params: params });
};
// 历史列表
export const getHistryByPage = (params) => {
    return Request.get(`${BaseApiUrl}/api/ConsultRecipe/GetHistry`, { params: params });
  };